export default __webpack_public_path__ + "static/media/katzDigitallogo.8c6a4f13.webp";